import { ActionBookAppointment } from '@/app/(app)/voice-agent/action-book';
import { ActionBusinessQuestions } from '@/app/(app)/voice-agent/action-business';
import { ActionCancelAppointment } from '@/app/(app)/voice-agent/action-cancel';
import { ActionFutureAppointments } from '@/app/(app)/voice-agent/action-future';
import { ActionPastAppointments } from '@/app/(app)/voice-agent/action-past';
import { ActionRescheduleAppointment } from '@/app/(app)/voice-agent/action-reschedule';

export function ActionsSettings() {
  return (
    <div className='flex w-full flex-col gap-4 rounded-lg border p-4'>
      <div className='px-1'>
        <h3 className='text-heading-lg font-semibold'>Actions</h3>
        <div className='text-sm text-muted-foreground'>Configure the actions that the voice agent can take.</div>
      </div>
      <ActionBookAppointment />
      <ActionPastAppointments />
      <ActionFutureAppointments />
      <ActionRescheduleAppointment />
      <ActionCancelAppointment />
      {/* <ActionNotesAppointment /> */}
      <ActionBusinessQuestions />
    </div>
  );
}
